export default "__VITE_ASSET__3apWvpUn__"